import { LocationImpl } from '../../types';

export const flaggableStatuses = ['Active', 'Trialing'];

export function getLocationStatus(location: LocationImpl) {
  if (location.status === 'NewLocation' || location.status !== 'default') {
    return location.status;
  }

  let status = 'Inactive';
  if (location.stripePriceId) {
    status = 'Active';

    if (new Date(location.trialEnd) > new Date()) {
      status = 'Trialing';
    }
  } else {
    if (location.trialEnd !== null && new Date(location.trialEnd) < new Date()) {
      status = 'TrialEnded';
    }
  }

  if (location.flagged && flaggableStatuses.includes(status)) {
    status = `Flagged${status}`;
  }

  return status;
}
